import React from "react";
import theme from "../styles/theme";
import styled from "styled-components";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import FaqSEO from "../components/SEO/FaqSEO";
import BlockTitle from "../components/Common/BlockTitle";
import PageHeading from "../components/Common/PageHeading";
import { regulations } from "../constants/regulations";

const Container = styled.div`
  & blockquote {
    margin: 0 0 25px 12px;
    border-left: 2px solid ${theme.colors.grey};
    padding: 25px;
    background: ${theme.colors.grey}20;
    border-radius: 4px;
  }

  & h2 {
    font-size: 20px;
    font-family: "Montserrat", sans-serif;
  }
  & blockquote > p {
    font-size: 16px;
    margin: 0px;
    line-height: 2;
    font-family: "Montserrat", sans-serif;
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  padding: 0px 0px 0px 0px;
  margin: 0px;
  color: ${theme.colors.dark};
  font-size: 16px;
  font-weight: 400;
  font-family: "Montserrat", sans-serif;sans-serif;
`;

const Regulament = styled.div`
  margin: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const FrequentlyAskedQuestion = () => {
  return (
    <>
      <FaqSEO />
      <Container style={{ marginTop: "24px" }}>
        <BlockTitle>
          <PageHeading>Регламент чемпіонату</PageHeading>
        </BlockTitle>
        <h2>Формат чемпіонату</h2>
        {regulations.map((regulation) => (
          <blockquote
            key={regulation.name}
            style={regulation.active ? undefined : { opacity: 0.5 }}
          >
            {regulation.name}
            <Regulament>
              <StyledLink to={regulation.url} target="_blank">
                <Button
                  size="small"
                  color="secondary"
                  variant="contained"
                  sx={{
                    fontFamily: "Roboto Condensed",
                    zIndex: 2,
                  }}
                  endIcon={<PictureAsPdfIcon sx={{}} />}
                >
                  Регламент
                </Button>
              </StyledLink>
            </Regulament>
          </blockquote>
        ))}
      </Container>
    </>
  );
};

export default FrequentlyAskedQuestion;
